import {TopToolbar, ListButton} from 'ra-ui-materialui'
import React from 'react'

export default ({basePath}) => (
  <TopToolbar>
    <ListButton basePath={basePath}/>
  </TopToolbar>
)
